module.exports = __webpack_public_path__ + "img/hcml_gallery8.3e053215.jpg";